import React from 'react';
import Headers from '../Components/Common/Header';
import ForgotPassword from '../Components/Pages/ForgotPassword/ForgotPassword';
import Loader from '../Components/Common/Loader';
import { useSelector } from 'react-redux';

export default function ChangePassword() {

  const { isLoading } = useSelector((state) => state.user);
  if (isLoading) {
    return (
      <Loader /> // Later, will handle this as a common component in Redux
    );
  }

  return (
    <>
      <Headers />
      <ForgotPassword />
    </>
  );
}
